import Swal from "sweetalert2";
import { i18n } from "@/i18n";

export const popupQuestion = async (message: string): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "question",
    text: i18n.global.t(message),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--in-progress)",
    cancelButtonColor: "var(--gray-400)",
    customClass: {
      htmlContainer: "swal-question-text",
    },
  });

  return res.isConfirmed;
};

export const confirmSave = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "question",
    text: i18n.global.t("messages.saveConfirm"),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--in-progress)",
    cancelButtonColor: "var(--gray-400)",
  });

  return res.isConfirmed;
};

export const confirmSend = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "question",
    text: i18n.global.t("messages.sendConfirm"),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--in-progress)",
    cancelButtonColor: "var(--gray-400)",
  });

  return res.isConfirmed;
};

export const confirmSendCancel = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "question",
    text: i18n.global.t("messages.sendCancelConfirm"),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--in-progress)",
    cancelButtonColor: "var(--gray-400)",
  });

  return res.isConfirmed;
};

export const showDuplicatedPKError = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "error",
    text: i18n.global.t("messages.duplication"),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--error)",
  });
  return res.isConfirmed;
};

export const popupSuccess = async (message: string): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "success",
    text: i18n.global.t(message),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--success)",
  });
  return res.isConfirmed;
};

export const confirmCompleteSave = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "success",
    text: i18n.global.t("messages.save"),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--success)",
  });
  return res.isConfirmed;
};

export const completeSend = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "success",
    text: i18n.global.t("messages.sendComplete"),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--success)",
  });
  return res.isConfirmed;
};

export const completeSendCancel = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "success",
    text: i18n.global.t("messages.sendCancelComplete"),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--success)",
  });
  return res.isConfirmed;
};

export const confirmDeleteSave = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "success",
    text: i18n.global.t("messages.delete"),
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    confirmButtonColor: "var(--success)",
  });
  return res.isConfirmed;
};

// 변경내역 취소 팝업
export const confirmDiscard = async (): Promise<boolean> => {
  const res = await Swal.fire({
    icon: "question",
    text: i18n.global.t("messages.changeConfirm"),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--in-progress)",
    cancelButtonColor: "var(--gray-400)",
  });

  return res.isConfirmed;
};

// 변경 불가 팝업
export const removeNotAllowed = async (): Promise<void> => {
  await Swal.fire({
    icon: "error",
    text: i18n.global.t("messages.removeNotAllowed"),
    showCancelButton: true,
    cancelButtonText: i18n.global.t("buttons.no"),
    confirmButtonText: i18n.global.t("buttons.yes"),
    confirmButtonColor: "var(--error)",
    cancelButtonColor: "var(--gray-400)",
  });
};

export const showError = async (message: string): Promise<void> => {
  await Swal.fire({
    title: message,
    icon: "error",
    confirmButtonColor: "var(--error)",
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    timer: 5000, // 5초 후 자동 닫힘
    timerProgressBar: true, // 진행바 표시
    showConfirmButton: true, // 확인 버튼 표시 (사용자가 즉시 닫을 수 있음)
    customClass: {
      title: "swal-title-error",
      confirmButton: "swal-button-error",
    },
  });
};

export const showSuccess = async (message: string): Promise<void> => {
  await Swal.fire({
    title: message,
    icon: "success",
    confirmButtonColor: "var(--success)",
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    timer: 5000, // 5초 후 자동 닫힘
    timerProgressBar: true, // 진행바 표시
    showConfirmButton: true, // 확인 버튼 표시 (사용자가 즉시 닫을 수 있음)
    customClass: {
      title: "swal-title-success",
      confirmButton: "swal-button-success",
    },
  });
};

export const showConfirm = async (message: string): Promise<boolean> => {
  const res = await Swal.fire({
    title: message,
    icon: "info",
    showCancelButton: true,
    cancelButtonColor: "var(--warning)",
    cancelButtonText: i18n.global.t("buttons.cancel"),
    confirmButtonColor: "var(--in-progress)",
    confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
    customClass: {
      title: "swal-title-info",
      confirmButton: "swal-button-confirm",
      cancelButton: "swal-button-cancel",
    },
  });

  return res.isConfirmed;
};
